import { Controller } from "@hotwired/stimulus"
import Pikaday from 'pikaday'
import Moment from 'moment';

// Connects to data-controller="spaces-date-pika"
export default class extends Controller {

  static targets = ['input', 'modal']

  connect() {
    const disabledDates = this.inputTarget.dataset.disabled.split(',');
    const activitiesPicker = new Pikaday({
      field: this.inputTarget,
      bound: false,
      minDate: new Date(),
      keyboardInput: false,
      firstDay: 1,
      format: 'DD/MM/YYYY',
      container: document.getElementById('spaces-calendar'),
    });
  }
  open() {
    this.modalTarget.classList.add('open');
  }
  close() {
    this.modalTarget.classList.remove('open');
  }
}
